import SqFetch from 'typescript/application/sq_fetch';
import { _handleResponse } from 'typescript/clients/utilities/handle_http_response';
import { PickupOption } from 'typescript/types/api/pickup_options';

// functions are controlled by the methods in this controller
// app/controllers/sq/api/products_controller.rb

export const PRODUCTS_BASE_URL = '/shop/api/v1/products';
export const BOPIS_AVAILABILITY_BY_POSTAL_CODE_URL =
  'find_bopis_availability_by_postal_code';

/**
 * Get add-ons for a specific product
 * @param productSlug - the product slug identifier
 * @param locale - the locale for the request
 * @returns add-ons data for the specified product
 */
export const getProductAddOns = async ({
  productSlug,
  locale,
}: {
  productSlug: string;
  locale: string;
}): Promise<any> => {
  const url = new URL(
    `${PRODUCTS_BASE_URL}/${productSlug}/add_ons`,
    window.location.origin,
  );
  url.searchParams.set('locale', locale);

  const response = await SqFetch.get(url.pathname + url.search, {
    credentials: 'omit', // omit cookies for CDN caching
  });

  return _handleResponse(response);
};

/**
 * Get pickup options near postal code for a given slug
 * @returns Promise<PickupOption[]> - array of pickup options to display
 */
export const listPickupOptions = async ({
  productSlug,
  postalCode,
}: {
  productSlug: string;
  postalCode: string;
}): Promise<PickupOption[]> => {
  const response = await SqFetch.post(
    `${PRODUCTS_BASE_URL}/${productSlug}/${BOPIS_AVAILABILITY_BY_POSTAL_CODE_URL}`,
    {
      postal_code: postalCode,
    },
  );

  return _handleResponse(response);
};
